<template>
  <vs-popup :active.sync="showPopup" id="LoadingDialog" style="z-index: 53001">
    <div class="flex items-center justify-center">
      <img src="@/assets/icons/loading.svg" class="spin" />
      <p class="w-full">처리중입니다...
        <span class="w-full mt-2" v-if="num > 0 && total > 0">({{num}}/{{total}} {{unit}})</span>
      </p>
    </div>
    <div class="w-screen h-screen absolute top-0 left-0 z-50" @click.stop></div>
  </vs-popup>
</template>

<script>
export default {
  data() {
    return {
      showPopup: false,
      num: 0,
      total: 0,
      unit: '',
    };
  },
  mounted() {
    window.addEventListener("loadingDialog", this.loadingDialog);
  },
  beforeDestroy() {
    window.removeEventListener("loadingDialog", this.loadingDialog);
  },
  methods: {
    loadingDialog(event) {
      const { open, num, total, unit } = event.detail;
      this.showPopup = open;
      this.num = open ? num : 0;
      this.total = open ? total : 0;
      this.unit = open ? unit : "";
    },
  },
};
</script>

<style lang="scss" scoped>
#LoadingDialog::v-deep {
  header {
    display: none;
  }
  .vs-popup {
    position: unset;
    width: 252px;
  }
}
p {
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: #757575;
  padding: 0 20px;
}
.spin {
  animation: lds-spinner 1s infinite steps(12);
}
@keyframes lds-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
